/*
The CMS tabs, in the order they are rendered, with the slug each one uses in
/cms/:tab.

One list, used by three places that used to disagree: MainTabsContainer renders
it, Tabs links to it, and MainWrapper resolves the URL back to a tab index
through it. MainWrapper used to keep its own hardcoded copy, which had drifted —
it was missing Loyalty, so every tab after Loyalty resolved one position early
and reloading /cms/tickets opened Venues. Loyalty itself was unreachable by URL.

Slugs are written out rather than derived with utils/slugify: they are part of
the URLs editors bookmark, so they should change only on purpose, and keeping
them literal lets cmsTabs.test.js run under plain `node`.

CommonJS on purpose: the colocated test runs without the webpack/babel
toolchain (this package has no test framework); components import it through
babel's CJS interop.
*/
const BASE_TABS = [
  { label: 'Structure', slug: 'structure' },
  { label: 'MAM', slug: 'mam' },
  { label: 'Users', slug: 'users' },
  { label: 'Loyalty', slug: 'loyalty' },
  { label: 'Subscriptions', slug: 'subscriptions' },
  { label: 'Products', slug: 'products' },
  { label: 'Comments', slug: 'comments' },
  { label: 'Logs', slug: 'logs' },
  { label: 'Emails', slug: 'emails' },
  { label: 'Events', slug: 'events' },
  { label: 'Artist sets', slug: 'artist-sets' },
  { label: 'Venues', slug: 'venues' },
  { label: 'Tickets', slug: 'tickets' },
  { label: 'PRO', slug: 'pro' },
];

/*
Radio is Primavera Sound only. The RDL manager is built from this same source
(APP_NAME=rdl) and has no radio, and ps-back refuses radio writes outside PS.
webpack.client.js's DefinePlugin replaces process.env.APP_NAME in the browser
bundle and the SSR server reads it from its environment, so both render the
same tab list. Appended last, so no existing tab URL changes position.
*/
const RADIO_TAB = { label: 'Radio', slug: 'radio' };

const CMS_TABS = process.env.APP_NAME === 'ps' ? [...BASE_TABS, RADIO_TAB] : BASE_TABS;

const DEFAULT_TAB_SLUG = 'structure';

// Slugs of tabs that were folded into another tab, and where their bookmarks go
// now. Sent emails became the Sent sub-tab of Emails on 2026-09-30.
const LEGACY_TAB_REDIRECTS = {
  'sent-emails': '/cms/emails?view=sent',
};

const tabIndexBySlug = (slug) => {
  if (!slug) return -1;
  return CMS_TABS.findIndex(tab => tab.slug === slug);
};

module.exports = {
  CMS_TABS,
  DEFAULT_TAB_SLUG,
  tabIndexBySlug,
  LEGACY_TAB_REDIRECTS,
};
